




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { IContent } from '../models';
@Component({
  components: {},
})
export default class DescriptionCard extends Vue {
  @Prop({ default: '' }) public html!: string;
  @Prop({ default: '' }) public subtitle!: string;
  private actors: Partial<IContent>[] = [];

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    await this.$store.actions.scenarios.updateList();
  }
}
